/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chat': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.3 24c-.1-.3-.1-.6.1-.9 1.4-2.2 2.1-4.8 2.1-7.4C29.5 8.2 23.4 2 15.8 2S2 8.2 2 15.8c0 7.6 6.2 13.8 13.8 13.8 2.7 0 5-.6 7-1.8.2-.1.5-.2.8-.1l5.4 1.5c0-.1-1.7-5.2-1.7-5.2zm4.2 6.2c.2.5-.1 1.1-.6 1.3-.2.1-.4.1-.6 0l-6.8-1.9c-2.3 1.3-4.8 1.9-7.7 1.9-8.7 0-15.8-7-15.8-15.7S7.1 0 15.8 0s15.8 7.1 15.8 15.8c0 2.9-.8 5.7-2.2 8.1-.1-.1 2.1 6.3 2.1 6.3zM11.6 14.7c-.6 0-1-.4-1-1s.4-1 1-1H20c.6 0 1 .4 1 1s-.4 1-1 1h-8.4zm0 6.3c-.6 0-1-.4-1-1s.4-1 1-1h4.2c.6 0 1 .4 1 1s-.4 1-1 1h-4.2z" _fill="#040006"/>'
  }
})
